import React from "react";

import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "../../notification.module.css";

import Badge from "../../Badge";
import {
  faCheck,
  faDownload,
  faExclamation,
  faFileExport,
} from "@fortawesome/free-solid-svg-icons";
import { faClock } from "@fortawesome/free-regular-svg-icons";

const NotificationItem = ({ notificationData, isLatest }) => {
  const { TaskEndDate, TaskStartDate, TaskStatus, TaskName, TaskDetail } =
    notificationData || {};

  const taskTime = TaskEndDate || TaskStartDate;
  const relativeTime = taskTime
    ? moment(taskTime, "DD-MM-YYYY HH:mm").fromNow()
    : "Unknown time";
  return (
    <div
      className={`${styles.notification_item_container} ${
        isLatest ? styles.latest : ""
      }`}
    >
      <div className={styles.notification_item_header}>
        <ExportBadge />
        {renderStatusBadge(TaskStatus)}
        <span
          className={styles.notification_time}
          title={moment(taskTime, "DD-MM-YYYY HH:mm").format(
            "YYYY-MM-DD HH:mm"
          )}
        >
          {relativeTime}
        </span>
      </div>
      <main className={styles.notification_item_body}>
        <p>{TaskName ?? "Unnamed Task"}</p>
        {TaskDetail && (
          <a href={TaskDetail} target="_blank" rel="noopener noreferrer">
            <button className={styles.notification_download_button}>
              <FontAwesomeIcon icon={faDownload} /> Download
            </button>
          </a>
        )}
      </main>
    </div>
  );
};

export default NotificationItem;

const ExportBadge = () => (
  <Badge
    label="Export"
    icon={faFileExport}
    backgroundColor="#F1F5F9"
    color="#334155"
  />
);

const CompletedBadge = () => (
  <Badge
    label="Completed"
    icon={faCheck}
    backgroundColor="#EDFFDE"
    color="#1F633B"
  />
);

const InProgressBadge = () => (
  <Badge
    label="In Progress"
    icon={faClock}
    backgroundColor="#FFF9DE"
    color="#63311F"
  />
);

const FailedBadge = () => (
  <Badge
    label="Failed"
    icon={faExclamation}
    backgroundColor="#FFDEDE"
    color="#640000"
  />
);

const renderStatusBadge = (status) => {
  switch (status) {
    case "Completed":
      return <CompletedBadge />;
    case "Executing":
      return <InProgressBadge />;
    case "Failed":
      return <FailedBadge />;
    default:
      return null;
  }
};
